"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEFAULT_MAP_PARALLELISM = 10;
// tslint:disable-next-line:no-any (types are enforced by overload signatures, validated by tests)
async function map(input, iteratee) {
    return mapLimit(input, DEFAULT_MAP_PARALLELISM, iteratee);
}
exports.map = map;
// tslint:disable-next-line:no-any (types are enforced by overload signatures, validated by tests)
async function mapLimit(input, limit, iteratee) {
    if (!input) {
        return [];
    }
    const isArray = Array.isArray(input);
    const size = (() => {
        if (isArray) {
            return input.length;
        }
        let count = 0;
        for (const __ in input) {
            ++count;
        }
        return count;
    })();
    const allValues = new Array(size);
    const results = new Array(size);
    let i = 0;
    for (const key in input) {
        const possiblyNumericKey = isArray ? i : key;
        allValues[size - 1 - i] = [input[key], i, possiblyNumericKey];
        ++i;
    }
    const execute = async () => {
        while (allValues.length > 0) {
            // tslint:disable-next-line:no-any
            const [val, index, key] = allValues.pop();
            results[index] = await iteratee(val, key);
        }
    };
    const allExecutors = [];
    for (let j = 0; j < limit; ++j) {
        allExecutors.push(execute());
    }
    await Promise.all(allExecutors);
    return results;
}
exports.mapLimit = mapLimit;
// tslint:disable-next-line:no-any (types are enforced by overload signatures, validated by tests)
async function mapSeries(input, iteratee) {
    return mapLimit(input, 1, iteratee);
}
exports.mapSeries = mapSeries;
// tslint:disable-next-line:no-any (types are enforced by overload signatures, validated by tests)
async function flatMap(input, iteratee) {
    if (!input) {
        return [];
    }
    const output = [];
    const nestedOutput = await map(input, iteratee);
    for (const partialOutput of nestedOutput) {
        // tslint:disable-next-line:no-any (could possibly be an array)
        if (partialOutput && partialOutput.length !== undefined) {
            // tslint:disable-next-line:no-any (is definitely an array)
            output.push(...partialOutput);
        }
        else {
            output.push(partialOutput);
        }
    }
    return output;
}
exports.flatMap = flatMap;
//# sourceMappingURL=map.js.map